import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useShepherdTour } from 'react-shepherd';

import useUserPreferences from '@main-hooks/useUserPreferences';
import { UserPreferencesKeys } from '@main-hooks/useUserPreferences/useUserPreferences.types';
import { steps, tourOptions } from '../PaymentLinkTour/steps';

const usePaymentLinkTour = () => {
  const { t } = useTranslation();
  const tour = useShepherdTour({ tourOptions, steps: steps(t) });
  const { updateOrCreateUserPreference } = useUserPreferences();

  const isTourActive = useRef(false);

  const onTourCanceled = () => {
    isTourActive.current = false;

    updateOrCreateUserPreference(
      UserPreferencesKeys.TUTORIAL_PAYMENT_LINK,
      true
    );
  };

  const onTourCompleted = () => {
    isTourActive.current = false;

    updateOrCreateUserPreference(
      UserPreferencesKeys.TUTORIAL_PAYMENT_LINK,
      true
    );
  };

  tour?.on('cancel', onTourCanceled);
  tour?.on('complete', onTourCompleted);

  const startTour = () => {
    if (!tour) return;
    if (isTourActive.current) return;

    tour.start();
    isTourActive.current = true;
  };

  return { startTour };
};

export default usePaymentLinkTour;
